import styled from 'styled-components'

import { View } from '@tabeo/scarf'

import logo from './logo.svg'

const Logo = styled(View)``

Logo.defaultProps = {
  as: 'img',
  src: logo,
}

export default Logo
